(() => {
  const tag = 'lyviol-cart-shipping-bar';
  if (customElements.get(tag)) return;

  function setText(node, value) {
    if (node.textContent !== value) node.textContent = value;
  }

  class LyviolShippingBar extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      this.observer = new MutationObserver(() => this.schedule());
      this.observer.observe(this, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
          'data-country', 'data-currency', 'data-base-currency',
          'data-language', 'data-total', 'data-count', 'data-goal-usd'
        ]
      });
      this.schedule();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }

    schedule() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        if (this.isConnected) this.render();
      });
    }

    render() {
      const message = this.querySelector('[data-message]');
      const meter = this.querySelector('[data-meter]');
      const track = this.querySelector('[data-track]');
      const fill = this.querySelector('[data-fill]');
      const percent = this.querySelector('[data-percent]');
      if (!message || !meter || !track || !fill || !percent) return;

      const data = this.dataset;
      const count = Number(data.count);
      const currency = data.currency;
      const es = data.language === 'es';
      this.hidden = !['US', 'MX'].includes(data.country) ||
        !Number.isSafeInteger(count) || count <= 0;
      if (this.hidden) return;

      const usd = Number(data.goalUsd);
      if (!Number.isFinite(usd) || usd <= 0) {
        this.hidden = true;
        return;
      }

      const fallback = () => {
        setText(message, es
          ? 'Umbral de envío gratis: US$' + usd + '. Consulta el importe en tu moneda al pagar.'
          : 'Free shipping threshold: US$' + usd + '. Check the amount in your currency at checkout.');
        meter.hidden = true;
        fill.style.width = '0%';
        track.setAttribute('aria-valuenow', '0');
        setText(percent, '');
      };

      const total = Number(data.total);
      if (!data.total || !Number.isSafeInteger(total) || total < 0 ||
          !['USD', 'MXN'].includes(currency)) {
        fallback();
        return;
      }

      let rate = 1;
      if (currency === 'MXN') {
        const info = window.Shopify?.currency;
        rate = Number(info?.rate);
        if (data.baseCurrency !== 'USD' || info?.active !== 'MXN' ||
            !Number.isFinite(rate) || rate <= 0) {
          fallback();
          return;
        }
      }

      try {
        // USD and MXN both have two decimal places. Round the threshold up.
        const goal = Math.ceil(usd * rate * 100 - 1e-8);
        if (!Number.isSafeInteger(goal) || goal <= 0) {
          fallback();
          return;
        }
        // Liquid cart.total_price is already in the customer's currency.
        const remaining = Math.max(goal - total, 0);
        const progress = Math.min(total / goal * 100, 100);
        const label = Math.floor(progress);
        const money = new Intl.NumberFormat(es ? 'es-MX' : 'en-US', {
          style: 'currency', currency, currencyDisplay: 'code'
        }).format(remaining / 100);

        let text;
        if (remaining === 0) {
          text = currency === 'MXN'
            ? (es ? '¡Has alcanzado el mínimo estimado para envío gratis!'
                  : "You've reached the estimated free-shipping minimum!")
            : (es ? '¡Has alcanzado el mínimo para envío gratis!'
                  : "Congrats! You've reached the free-shipping minimum!");
        } else {
          text = es
            ? 'Te faltan ' + (currency === 'MXN' ? 'aprox. ' : '') + money + ' para envío gratis.'
            : "You're " + (currency === 'MXN' ? 'approximately ' : '') + money + ' away from free shipping.';
        }

        setText(message, text);
        setText(percent, label + '%');
        track.setAttribute('aria-valuenow', String(label));
        fill.style.width = progress + '%';
        meter.hidden = false;
      } catch {
        fallback();
      }
    }
  }

  customElements.define(tag, LyviolShippingBar);
  const refresh = () => document.querySelectorAll(tag).forEach(bar => bar.schedule());
  window.addEventListener('load', refresh);
  window.addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', refresh);
})();
